import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { useStore } from 'vuex'

import { hasTierWizard } from '@/config/membershipTierWizardSteps'
import MembershipTierNeue from '@/view/store/MembershipTierNeue.vue'
import MembershipTierWizard from '@/view/store/membershipTierWizard/MembershipTierWizard.vue'


export default {
  __name: 'MembershipTierRoute',
  setup(__props) {

const route = useRoute()
const store = useStore()
const tierId = computed(() => String(route.params.id))
const wizardOn = computed(() => hasTierWizard(store.state.loggedInUser))

return (_ctx, _cache) => {
  return (wizardOn.value)
    ? (_openBlock(), _createBlock(MembershipTierWizard, {
        key: tierId.value,
        "tier-id": tierId.value
      }, null, 8, ["tier-id"]))
    : (_openBlock(), _createBlock(MembershipTierNeue, { key: tierId.value }))
}
}

}